import React from "react";
import { Page } from "@vwpfs/mary-air-lib/components/air/09-views/01-sections/Page";
import { PageDisplay, Pages, SubPages, SubPageDisplay } from "../../../../store/AppDisplays";
import { Header } from "@vwpfs/mary-air-lib/components/air/09-views/01-sections/Header";
import { Container } from "@vwpfs/mary-air-lib/components/air/03-base/Container";
import { Grid } from "@vwpfs/mary-air-lib/components/air/03-base/Grid";
import { Div } from "@vwpfs/mary-air-lib/components/air/03-base/Div";
import { InfoCard } from "@vwpfs/mary-air-lib/components/air/06-molecules/InfoCard";
export const Manage: React.FunctionComponent<{}> = () => (
    <Page>
        <Container
            theme={{
                padding: {
                    "": { y: 3 },
                    "sm": { y: 4 },
                },
            }}
        >
            <Header
                title={PageDisplay[Pages.MANAGE].title}
                description={PageDisplay[Pages.MANAGE].description}
            />
            <Div className="scl-b-row">
                {PageDisplay[Pages.MANAGE].subpages
                    // eslint-disable-next-line max-len
                    .filter((page: SubPages) => page === SubPages.MANAGE_BRANDS || page === SubPages.MANAGE_MODELS || page === SubPages.MANAGE_BUSINESS_RULE_VIOLATIONS)
                    .map((page: SubPages, index) => (
                        <Grid key={index} size={{ xs: 12, md: 6, lg: 3 }}>
                                <InfoCard
                                    title={SubPageDisplay[page].title}
                                    description={SubPageDisplay[page].description}
                                    navLink={SubPageDisplay[page].path}
                                />
                        </Grid>
                    ))}
            </Div>
        </Container>
    </Page>
);
